import { IconObjectTree } from '@core/icons'
import type { FC } from 'react'
import { useState } from 'react'

import type { ProjectObjectType } from '../types'
import css from './Toolbar.css'
import { ToolbarItem } from './ToolbarItem'

type ToolbarProps = {
  showObjectsPropertiesSidebar: () => void
  onObjectsButtonClick: () => void
}

export const Toolbar: FC<ToolbarProps> = ({ onObjectsButtonClick }) => {
  const items: ProjectObjectType[] = [
    {
      text: 'Объекты',
      icon: IconObjectTree,
      onClick: onObjectsButtonClick,
    },
  ]

  const [selectedItem, setSelectedItem] = useState<ProjectObjectType>(items[0])

  return (
    <div className={css.container}>
      <div className={css.items}>
        {items.map(i => (
          <ToolbarItem
            key={i.text}
            item={i}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
          />
        ))}
      </div>
    </div>
  )
}
